import { render, staticRenderFns } from "./EmailVerificationNotice.vue?vue&type=template&id=7d562e8c&scoped=true"
import script from "./EmailVerificationNotice.vue?vue&type=script&lang=js"
export * from "./EmailVerificationNotice.vue?vue&type=script&lang=js"
import style0 from "./EmailVerificationNotice.vue?vue&type=style&index=0&id=7d562e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d562e8c",
  null
  
)

export default component.exports